import Api from "./Api";
import axios from "axios";
// import integrationApi from "./integrationApi";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export default {
  checkDuplicated(params) {
    console.log("A&A")

    return axios.post(
      `${process.env.VUE_APP_BASE_URL_PASSPORT}/api/check-unique-field`,
      params,
      {
        headers: headers,
      }
    );
  },
  entityBySubdomain(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(
      `${process.env.VUE_APP_BASE_URL}/api/entity_by_subdomain`,
      { params: data },
      {
        headers: headers,
      }
    );
  },
  passportAuth(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.post(
      `${process.env.VUE_APP_BASE_URL}/api/passport_auth`,
      data,
      {
        headers: headers,
      }
    );
  },
  logout() {
    return Api().get(`/logout`);
  },
  registerUser(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.post(
      `${process.env.VUE_APP_BASE_URL_PASSPORT}/api/register`,
      data, {
      headers: headers,
    }
    ).then(response => {
      return Promise.resolve(response)
    })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  login(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.post(`${process.env.VUE_APP_BASE_URL}/api/login`, data, {
      headers: headers,
    });
  },
  userDetails() {
    return Api().get(`/user_details`);
  },
  getClientSecret(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.post(
      `${process.env.VUE_APP_INTEGRATION_URL}/api/get-client-secret`,
      data, {
      headers: headers,
    }
    ).then(response => {
      return Promise.resolve(response)
    })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  getIntegrationToken(data) {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.post(
      `${process.env.VUE_APP_INTEGRATION_URL}/api/access-token`,
      data, {
      headers: headers,
    }
    ).then(response => {
      return Promise.resolve(response)
    })
      .catch(error => {
        return Promise.reject(error.response);
      });
  },
  getPassportToken() {
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return axios.get(`${process.env.VUE_APP_BASE_URL}/api/generate_passport_token`, {
      headers: headers,
    });
  },
  updateUserRoleAfterChange(params) {
    return Api().get('/user-role',params);
  },
  getUserResourceDataById(id) {
    return Api().get(`/get_user_details_by_user_resource_id/${id}`);
  },
  changeLanguage(params) {
    return Api().post('/change-lang',{lang : params});
  },
};
